import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import AwsConfig from '../../Config/AwsConfig'
// import ListMoviesSearch from '../../Services/Queries/LIstMoviesSearch'
import SearchListsAndCollections from '../../Services/Queries/SearchListsAndCollections'

export default function CrudSearchBar(props) {
  const {
    isVisiable,
    toggleSearchbar,
    selectedListCrud,
    sendSelectedList,
    valueChanged,
    setvalueChanged,
  } = props
  const [searchList, setSearchList] = useState('')
  const [searchedData, setSearchedData] = useState([])
  const [selectedList, setSelectedList] = useState([...selectedListCrud])
  const [errorMessage, setErrorMessage] = useState(false)
  const SearchList = async value => {
    setSearchList(value)
    // }

    // const searchedData = async () => {
    if (value === '') {
      setSearchedData([])
    } else {
      const input = {
        type: 'lists',
        search: value,
        sortBy: 'time',
        sortOrder: 'asc',
        from: 0,
        limit: 10,
      }
      console.log(input, 'input---')
      const searchedData = await SearchListsAndCollections(input)

      setSearchedData(searchedData)
    }
  }

  const SendSelectedToCrud = () => {
    sendSelectedList(selectedList)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.selectedPersons = true
    setvalueChanged(valueChangedTemp)
  }

  const imageOkButton = () => {
    SendSelectedToCrud()
    toggleSearchbar(false)
  }

  const SelectedList = (event, index) => {
    const selectedListTemp = [...selectedList]
    if (selectedListTemp.some(item => item.SK === searchedData.items[index].SK)) {
      setErrorMessage(true)
    } else {
      setErrorMessage(false)
      selectedListTemp.push(searchedData.items[index])
      setSelectedList(selectedListTemp)
    }
  }

  const removeSelected = (event, index) => {
    const selectedListTemp = [...selectedList]
    selectedListTemp.splice(index, 1)
    setSelectedList(selectedListTemp)
  }

  const poster = url => {
    if (url) {
      const cdnurl = AwsConfig.movieCdnUrl
      if (url && !url.includes(cdnurl)) {
        url = cdnurl + url
        return url
      }

      return url
    }

    return ''
  }

  return (
    <Modal
      show={isVisiable}
      dialogClassName='modal-90w'
      // fullscreen={'md-down'}
      onHide={() => toggleSearchbar(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Search Lists:</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          className='rounded'
          placeholder={'search  Lists'}
          value={searchList}
          onChange={event => SearchList(event.target.value)}
        />
        {searchedData.items &&
          searchedData.items.map((item, index) => (
            <div key={index} onClick={event => SelectedList(event, index)}>
              <ul className='list-group list-group-flush mb-1'>
                {item.title_En && (
                  <li className='list-group-item'>
                    <div className='media d-flex justify-content-center align-items-center'>
                      <img
                        style={{ width: '2rem', height: '2rem' }}
                        className='rounded-circle mr-3'
                        src={poster(
                          item && item.movieListImage
                            ? item.movieListImage
                            : item && item.dynamicListImage
                            ? item.dynamicListImage
                            : '',
                        )}
                        alt={item.title_En}
                      />
                      <div className='media-body align-self-center'>
                        <label>{item.title_En}</label>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          ))}
      </Modal.Body>
      <Modal.Footer>
        {errorMessage && <div className='alert alert-danger'>Selected List already added</div>}
        {selectedList?.map((item, index) => (
          <div key={index} className='d-flex'>
            <ul className='list-group list-group-flush mb-1'>
              <li className='list-group-item'>
                <div
                  className='media d-flex justify-content-center align-items-center rounded'
                  style={{ border: '1px solid gray' }}
                >
                  <img
                    style={{ width: '2rem', height: '2rem' }}
                    className='rounded-circle mr-3'
                    src={poster(
                      item && item.movieListImage
                        ? item.movieListImage
                        : item && item.dynamicListImage
                        ? item.dynamicListImage
                        : '',
                    )}
                    alt={item ? item.title_En : ''}
                  />
                  <div className='media-body align-self-center'>
                    <label>{item ? item.title_En : ''}</label>
                  </div>
                  <span
                    className='badge badge-danger badge-pill'
                    onClick={event => removeSelected(event, index)}
                  >
                    X
                  </span>
                </div>
              </li>
            </ul>
          </div>
        ))}
        <button type='button' onClick={() => imageOkButton()} className='btn btn-primary'>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  )
}
